/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-05-23 09:59:10
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-29 16:47:29
 */
export const modulesIntroduce = {
  数据维护: '实时跟进并维护驾驶舱中的数据',
  企业互动:
    '将丽水市现有的企业基础信息和扩展信息进行整合，建立企业数据库，同时在企业标签化管理的基础上，实现向企业推送各类信息',

  码上诉求:
    '打通企业咨询的处理链，建设面向企业的需求和问题反馈入口，形成企业咨询填写、提交、解决、反馈的服务闭环。',

  码上用券: '服务券批次管理，企业领券白名单库管理、订单管理和机构兑现管理',

  码上中介:
    '为企业提供服务商品中介服务事项、中介服务机构、服务商品展示、在线订购、订单管理等功能和相关商品信息查询服务',

  码上政策:
    '实现政策查看到政策兑现一条龙服务，通过企业标签和政策标签的双向匹配，政府部门及时向企业推送各类涉企政策，实现政策的精准直达、掌上阅览、在线咨询。',

  码上担保:
    '查询担保产品、申请担保、查询结果、消息通知、担保产品管理、担保申请管理、担保评审结果反馈等功能。',

  码上基金:
    '码上基金应用实现高质量绿色发展产业基金的宣传和在线咨询，企业可详细了解高质量绿色发展产业基金的主要情况',

  码上代办: '代办事项管理、代办申请管理、代办受理分配和代办评价管理',

  码上问卷:
    '实现问卷调查线上化，问卷范围可涵盖丽水市所有企业，帮助管理部门从宏观角度更方便快捷的掌握本地企业现状、需求及意见。',

  码上积分:
    '通过设置积分获取规则，累计企业积分，根据企业积分及排名情况，可获取相应的企业奖励兑换相应中介服务，以此来调动调动企业积极性。',

  码上直播:
    '聚焦线上知识传播，赋能企业管理，平台可按管理员需求发布线上讲堂内容（视频），并实现跟踪管理，企业可登录专区查看相关讲堂资料，确保企业学习质量。',

  码上活动:
    '活动专场自定义、现场推广可分享、区县联动更高效，有效为活动次数和自主活动办理提供本地化更个性化的操作服务模式。',

  便企导航管理:
    '归集涉企相关县内政务公开信息（联系方式、负责人、电话（留言版、部门信息、二维码等）至企业码专区进行分类展示，建立政府部门公共信息码上公开',

  我的专员:
    '通过走访记录功能模块的搭建，支持绑定专员与企业，实现专员走访信息进行全留痕。',

  政策汇编:
    '实现企业移动端用户以电子书形式进行政策的分类展示，并可通过关键字搜索查询。',

  丽企之家驾驶舱:
    '在可视化成果展示上，充分利用业内领先的大数据可视化展示技术，基于多种图表及展示形式，结合业务层面的多角度分析，充分为平台提供技术和业务支撑。',

  企业服务平台数据统计:
    '以实时动态的工业企业信息和运营服务管理要求为出发点，通过对丽水市政策、诉求、服务劵等专题进行有效数据分析，实时反映全市企业服务数据的运行状态',

  通知公告: '涉企资讯消息一站式发布与管理',
  企业信息:
    '企业基本信息管理。包括企业名称、统一信用代码、企业地址、企业联系人联系方式、企业经营范围等信息'
}
